module.exports = __webpack_public_path__ + "static/media/parallax-flip.30c46d7d.svg";